import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Language"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M18 14.25H13.5V15.75H18V14.25zM22.5 11.25H13.5V12.75H22.5V11.25zM22.5 8.25H13.5V9.75H22.5V8.25zM10.5 15.75V14.25H6.75V12.75H5.25V14.25H1.5V15.75H7.6611C7.38544 16.8756 6.81131 17.9061 5.99918 18.7328 5.57349 18.2887 5.2086 17.7901 4.91408 17.25H3.25005C3.6313 18.1652 4.17653 19.0031 4.85887 19.7225 4.05483 20.2951 3.17731 20.7569 2.25 21.0953L2.77658 22.5C3.93062 22.0797 5.0153 21.4891 5.9946 20.7478 6.97764 21.4894 8.06592 22.08 9.22342 22.5L9.75 21.0953C8.82318 20.7575 7.94602 20.2966 7.1421 19.725 8.20071 18.6303 8.91266 17.2476 9.1887 15.75H10.5zM8.37495 9.75H9.99975L6.5625 1.5H4.9374L1.5 9.75H3.1248L3.75 8.25H7.75012L8.37495 9.75zM4.37483 6.75 5.74988 3.45 7.125 6.75H4.37483z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Language.vue"]]);
